var exports = {
  "V": "authorLoginLink__51Riy1",
  "d": "noProfileLink__RnIjqX",
};

module.exports = exports;
